<template>
	<div>
		<myheader headTitle="拒签理由"></myheader>
		<div class="all_main" id="main">
			<div class="all_content_padding" id="uptop" style="overflow-y: auto;">
				<div class="all_details_content_card">
					<div class="text16 textcolor333 font_weight_700">{{contractInfo.contractName}}</div>
					<div class="margin_top_2">
						<span class="text12 textcolor999" style="display: inline-block; width: 20%;">合同编号</span>
						<span class="text12 textcolor999">{{contractInfo.contractCode}}</span>
					</div>
					<div class="margin_top_1">
						<span class="text12 textcolor999" style="display: inline-block; width: 20%;">接收时间</span>
						<span class="text12 textcolor999">{{contractInfo.createdTime}}</span>
					</div>
					<div class="margin_top_1">
						<span class="text12 textcolor999" style="display: inline-block; width: 20%;">截止时间</span>
						<span class="text12 textcolor999">{{contractInfo.expireDate}}</span>
					</div>
				</div>
				<div class="margin_top_10">
					<span class="text12 textcoloblack font_weight_700 all_tips_red_after"
						style="margin-left: .5rem;display: inline-block; width: 83%;">
						拒签理由</span>
					<span class="text12 textcolor999">{{denyWord.length+'/500'}}</span>
				</div>
				<div class="all_details_content_card margin_top_2" id="area">
					<textarea class="area text12 textcolor333" placeholder="在此输入内容" v-model="denyWord" maxlength="500"
						style="overflow-y: auto;">
						</textarea>
				</div>
				<div style="height: 3.5rem;"></div>
				<div class="all_tips_bottom_card" id="bottom">
					<button class="all_button24 width_100 text16 bmain_active" @click="sumbit()">确定拒签</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				//合同信息
				contractInfo: '',
				//拒签内容
				denyWord: '',
				//屏幕高度
				height: 0,
			}
		},
		methods: {
			//提交拒签，并返回合同
			sumbit() {
				if (!this.denyWord) {
					this.$Toast('请输入拒签原因...')
					return
				}
				this.$store.dispatch(this.$LoadShow, true)
				this.$post("/contract/api/cancel", {
					contractId: this.contractId,
					corpId: this.corpId,
					reason: this.denyWord
				}).then((res) => {
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success) {
						this.$store.commit('changeContractStatus', true)
						this.$Toast('拒签成功！')
						this.$router.go(-1)
					} else {
						this.$Toast(res.message || res.messageDetail || '拒签失败，请重试！')
					}
				});
			},
			//获取合同详情
			getContractDetails() {
				this.contractId = this.$route.query.contractId
				this.corpId = this.$route.query.corpId
				this.$store.dispatch(this.$LoadShow, true)
				this.$post("/contract/api/getContractDetail?contractId=" + this.contractId)
					.then((res) => {
						this.$store.dispatch(this.$LoadShow, false)
						if (res.success && res.data) {
							this.contractInfo = res.data
						}
					});
			},
			//监听高度变化做相应的操作
			makeResize() {
				//键盘弹出
				//console.log('makeResize')
				if (this.height > 0 && document.body.clientHeight < this.height) {
					//console.log('makeResize执行')
					let b = document.getElementById('bottom')
					b.scrollIntoView()
				}
				if (this.height > 0 && document.body.clientHeight == this.height) {
					//console.log('makeResize等于执行')
				}
			},
		},
		computed: {
			//获得高度
			resize() {
				//console.log('resize')
				//console.log(this.height)
				if (this.height == 0) {
					this.height = document.body.clientHeight
				}
				//console.log(this.height)
			},
		},
		mounted() {
			window.addEventListener('resize', this.resize);
			window.addEventListener('resize', this.makeResize);
			this.getContractDetails()
		},
	}
</script>

<style scoped lang="scss">
	@import "../../styles/global.css";
</style>